import React, { useEffect, useState, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useHttp } from 'hooks/http.hook';
import { getDayMounthYear } from 'helpers/date';
import { NEWS } from 'endpointsConst';

import styles from './styles.module.scss';

import { Image } from '@tiptap/extension-image';
import { Link as TipTapLink } from '@tiptap/extension-link';
import { Bold } from '@tiptap/extension-bold';
import { Strike } from '@tiptap/extension-strike';
import { Italic } from '@tiptap/extension-italic';
import { Document } from '@tiptap/extension-document';
import { Paragraph } from '@tiptap/extension-paragraph';
import { Text } from '@tiptap/extension-text';
import { generateHTML } from '@tiptap/html';

import parse from 'html-react-parser';

import NotFoundNews from './NotFoundNews';
import Loading from '../../../Loading';
import Typography from 'components/Typography';
import BackButton from 'components/common/BackButton';

export default function SingleNewsPage() {
  const [data, setData] = useState({});
  const [isNewsFound, setIsNewsFound] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const { request } = useHttp();
  const { t } = useTranslation();
  // `id` is either a slug (new links) or a UUID (legacy links) — the API resolves both
  const { id } = useParams();

  useEffect(() => {
    request(NEWS + '/' + id)
      .then((res) => {
        setData(res.data);
        setIsLoading(false);
      })
      .catch((_) => {
        setIsNewsFound(false);
        setIsLoading(false);
      });
  }, [id, request]);

  const textEditorHTML = useMemo(() => {
    if (data.description) {
      return generateHTML(data.description, [
        Document,
        Paragraph.configure({
          HTMLAttributes: {
            class: styles.textEditorP,
          },
        }),
        Text,
        Bold,
        Italic,
        Strike,
        // Ссылки в тексте новости ведут на внешние источники, поэтому открываем их в новой вкладке
        TipTapLink.configure({
          HTMLAttributes: {
            class: styles.textEditorLink,
            target: '_blank',
            rel: 'noopener noreferrer nofollow',
          },
        }),
        Image.configure({
          HTMLAttributes: {
            class: styles.textEditorImg,
          },
        }),
      ]);
    }
    return '<p></p>';
  }, [data.description]);

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <div className={styles.news}>
            <BackButton />
            <Typography variant="h2" className={styles.news__title}>
              {data.title || ''}
            </Typography>
            {data.creation_date && (
              <Typography variant="p" className={styles.news__date}>
                {getDayMounthYear(data.creation_date)}
              </Typography>
            )}
            <div className={styles.news__container}>
              <img className={styles.news__image} src={data.preview} alt={data.title} />
            </div>
            {!isNewsFound ? <NotFoundNews /> : <div className={styles.news__breadcrumb}>{parse(textEditorHTML)}</div>}
          </div>
        </>
      )}
    </>
  );
}
